module.exports = "pegasus/assets/blocks/column-7-basic.png";